import React, { useEffect, useState } from "react";
import "./Home.css";
import API_BASE_URL from "../../config";
import SEO from "../../Components/SEO/SEO.jsx";
import Image from "../../Components/Image/Image";
import Loader from "../../Components/Loader/Loader";
import {
  ArrowRight,
  Clock,
  MapPin,
  Phone,
  Sparkles,
  Star,
  Utensils,
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { categoriesService } from "../../Modules/Services/categories.service.ts";

const HIGHLIGHTS = [
  {
    icon: Utensils,
    title: "Свежая кухня",
    text: "Готовим из отборных продуктов каждый день",
  },
  {
    icon: Clock,
    title: "Быстро",
    text: "Самовывоз за 15 минут или доставка по городу",
  },
  {
    icon: Star,
    title: "Любимое место",
    text: "Десятки тёплых отзывов наших постоянных гостей",
  },
];

const Home = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const cats = await categoriesService.getCategories();
        setCategories(cats || []);
      } catch (error) {
        console.error("Ошибка при получении данных:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <Loader />;

  return (
    <div className="Home">
      <SEO
        title="Кафе Шахризада — восточная кухня и кофе"
        description="Меню кафе Шахризада: шаурма, плов, арабский кофе и восточные сладости с доставкой и самовывозом."
        keywords="меню, цены, шаурма, кофе, десерты, восточная кухня"
      />

      <section className="Home--Hero fade-in">
        <div className="Home--HeroInner">
          <div className="Home--HeroText">
            <span className="section-eyebrow">
              <Sparkles size={14} /> Восточное кафе
            </span>
            <h1 className="Home--HeroTitle">
              Вкус Востока <em>в каждом блюде</em>
            </h1>
            <p className="Home--HeroLead">
              Аромат специй, свежая выпечка и ароматный кофе — всё, чтобы день
              стал тёплым и сытным. Закажите любимое блюдо в пару кликов.
            </p>
            <div className="Home--HeroActions">
              <a href="#categories" className="btn btn--primary">
                Открыть меню <ArrowRight size={18} />
              </a>
              <Link to="/about" className="btn btn--ghost">
                О нас
              </Link>
            </div>
            <div className="Home--HeroMeta">
              <div>
                <Phone size={16} />
                <span>+7 (924) 870-51-07</span>
              </div>
              <div>
                <MapPin size={16} />
                <span>Олёкминск, Партизанская 1</span>
              </div>
              <div>
                <Clock size={16} />
                <span>Пн – Сб: 9:00 – 21:00</span>
              </div>
            </div>
          </div>

          <div className="Home--HeroVisual" aria-hidden="true">
            <div className="Home--HeroOrb Home--HeroOrb--1" />
            <div className="Home--HeroOrb Home--HeroOrb--2" />
            <div className="Home--HeroBadge">
              <Star size={14} />
              <span>Любимое кафе города</span>
            </div>
            <div className="Home--HeroPoster">
              <span className="Home--HeroPosterCaption">сегодня</span>
              <span className="Home--HeroPosterTitle">Свежая лепешка</span>
              <span className="Home--HeroPosterPrice">с печи</span>
            </div>
          </div>
        </div>
      </section>

      <section className="Home--Highlights">
        {HIGHLIGHTS.map(({ icon: Icon, title, text }) => (
          <div key={title} className="Home--Highlight">
            <div className="Home--HighlightIcon">
              <Icon size={20} />
            </div>
            <div>
              <div className="Home--HighlightTitle">{title}</div>
              <div className="Home--HighlightText">{text}</div>
            </div>
          </div>
        ))}
      </section>

      <section id="categories" className="Home--Section">
        <div className="Home--SectionHead">
          <span className="section-eyebrow">
            <Utensils size={14} /> Меню
          </span>
          <h2 className="section-title">Категории блюд</h2>
          <p className="muted Home--SectionLead">
            Выберите категорию и откройте то, что любите больше всего.
          </p>
        </div>

        {categories.length === 0 ? (
          <div className="Home--Empty">Пока меню в работе. Загляните позже.</div>
        ) : (
          <div className="Home--Categories">
            {categories.map((category, index) => (
              <button
                key={category.category_id}
                type="button"
                className="Home--Category fade-up"
                style={{ animationDelay: `${index * 40}ms` }}
                onClick={() =>
                  navigate(`/category/${category.category_id}`)
                }
              >
                <div className="Home--CategoryMedia">
                  {category.category_image_url ? (
                    <Image
                      src={`${API_BASE_URL}${category.category_image_url}`}
                      alt={category.category_name}
                      className="Home--CategoryImg"
                    />
                  ) : (
                    <div className="Home--CategoryPlaceholder">
                      <Utensils size={28} />
                    </div>
                  )}
                  <span className="Home--CategoryGlow" />
                </div>
                <div className="Home--CategoryBody">
                  <span className="Home--CategoryTitle">
                    {category.category_name}
                  </span>
                  <span className="Home--CategoryArrow">
                    <ArrowRight size={18} />
                  </span>
                </div>
              </button>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default Home;
